import { fork, takeEvery, takeLatest } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import { initApp, signOut } from '@lib/actions';
import { DISPATCH_FETCH_FONT_FAMILIES, DISPATCH_REFRESH_CONTEXT } from '@lib/actions/actionTypes';
import changeLocale from '@lib/actions/changeLocale';
import saga from '@lib/actions/saga';
import { sagaFetchFontFamilies, sagaRefreshContext } from '@lib/sagas';

import sagaChangeLocale from './sagaChangeLocale';
import sagaInitApp from './sagaInitApp';
import sagaSignOut from './sagaSignOut';
import sagaWatchers from './sagaWatchers';

export default function* sagas() {
  yield fork(saga);
  yield fork(sagaWatchers);

  yield takeLatest(DISPATCH_FETCH_FONT_FAMILIES, sagaFetchFontFamilies);
  yield takeLatest(DISPATCH_REFRESH_CONTEXT, sagaRefreshContext);

  // sagas patient-web-app only
  yield takeEvery(getType(changeLocale), sagaChangeLocale);
  yield takeLatest(getType(initApp.request), sagaInitApp);
  yield takeLatest(getType(signOut), sagaSignOut);
}
